import { createBrowserClient } from "@supabase/ssr";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

export const isSupabaseConfigured = !!SUPABASE_URL && !!SUPABASE_ANON_KEY;

export function createClient() {
  if (!isSupabaseConfigured) {
    // Return a mock client for dev mode — returns empty successful responses
    const mockSuccess = { data: [], error: null };
    const mockSingle = { data: null, error: null };

    return {
      auth: {
        getUser: async () => ({
          data: { user: { id: "dev-user", email: "dev@smartads.local" } },
          error: null,
        }),
        getSession: async () => ({
          data: { session: null },
          error: null,
        }),
        signInWithPassword: async () => ({
          data: { user: { id: "dev-user", email: "dev@smartads.local" }, session: null },
          error: null,
        }),
        signUp: async () => ({
          data: { user: { id: "dev-user", email: "dev@smartads.local" }, session: null },
          error: null,
        }),
        signOut: async () => ({ error: null }),
        onAuthStateChange: () => ({
          data: { subscription: { unsubscribe: () => {} } },
        }),
      },
      from: () => {
        const chain: Record<string, unknown> = {
          select: () => chain,
          eq: () => chain,
          neq: () => chain,
          in: () => chain,
          gte: () => chain,
          lte: () => chain,
          gt: () => chain,
          lt: () => chain,
          like: () => chain,
          ilike: () => chain,
          is: () => chain,
          order: () => chain,
          limit: () => chain,
          range: () => chain,
          single: () => Promise.resolve(mockSingle),
          maybeSingle: () => Promise.resolve(mockSingle),
          insert: () => Promise.resolve(mockSuccess),
          update: () => chain,
          upsert: () => Promise.resolve(mockSuccess),
          delete: () => Promise.resolve(mockSuccess),
          data: [],
          error: null,
          then: (resolve: (v: unknown) => void) => resolve(mockSuccess),
        };
        return chain;
      },
    } as ReturnType<typeof createBrowserClient>;
  }

  return createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY);
}
